import React, { useEffect, useState } from 'react';

import {
  Button,
  Checkbox,
  ExpandableLabel,
  InputText,
} from '@/components/elements';
import Mail from '@/icons/small/Mail.svg';

import {
  StyledAlert,
  StyledFieldset,
  StyledForm,
  StyledHouse,
  StyledIconContainer,
  StyledIntroIdle,
  StyledRichText,
} from './Newsletter.styled';
import type { IIdleStateProps } from './Newsletter.types';
import { type NewsletterFormData } from './subscribeNewsletterAPI';

export const IdleState = ({
  onHandleSubmit,
  idleLabels,
  validation,
}: IIdleStateProps) => {
  const [formData, setFormData] = useState<NewsletterFormData>({
    email: '',
    consentsDataProcessing: false,
  });

  const [openGeneral, setOpenGeneral] = useState(false);
  const [openConsent, setOpenConsent] = useState(false);

  useEffect(() => {
    const hasGeneralError = !!(
      validation.email && validation.consentsDataProcessing
    );
    setOpenGeneral(hasGeneralError);
    setOpenConsent(!hasGeneralError && !!validation.consentsDataProcessing);
  }, [validation]);

  const selectHandle = () => {
    setFormData({
      ...formData,
      consentsDataProcessing: !formData.consentsDataProcessing,
    });
  };

  return (
    <>
      <StyledIconContainer>
        <StyledHouse />
      </StyledIconContainer>
      <StyledIntroIdle
        headline={{
          label: idleLabels.headline,
          size: 'h3',
        }}
        subtitle={idleLabels.title}
        copy={idleLabels.subHeadline}
        nested
      />
      <StyledForm onSubmit={(e) => onHandleSubmit(e, formData)}>
        {openGeneral && (
          <StyledAlert variant="error" onClose={() => setOpenGeneral(false)}>
            {idleLabels.error.general}
          </StyledAlert>
        )}
        <StyledFieldset $hasConsentError={openConsent}>
          <InputText
            placeholder={idleLabels.placeholder}
            startAdornment={<Mail />}
            size="m"
            type="email"
            name="newsletterEmail"
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.currentTarget.value })
            }
            error={!!validation.email}
            helperText={validation.email ? idleLabels.error.email : ''}
          />
          <Button label={idleLabels.button} variant="secondary" type="submit" />
        </StyledFieldset>
        {openConsent && (
          <StyledAlert variant="error" onClose={() => setOpenConsent(false)}>
            {idleLabels.error.consent}
          </StyledAlert>
        )}
        <Checkbox
          name="consentsDataProcessing"
          onChange={selectHandle}
          isRequired
          id="consentsDataProcessing"
          label={
            <ExpandableLabel
              isRequired
              maxLines={3}
              readMoreLabel={idleLabels.readMore}
              readLessLabel={idleLabels.readLess}
            >
              <StyledRichText content={idleLabels.consentText} />
            </ExpandableLabel>
          }
          error={!!validation.consentsDataProcessing}
        />
      </StyledForm>
    </>
  );
};
